import styles from './DtmfButton.module.css'

const SUB_LABELS = {
    '1': '',
    '2': 'ABC',
    '3': 'DEF',
    '4': 'GHI',
    '5': 'JKL',
    '6': 'MNO',
    '7': 'PQRS',
    '8': 'TUV',
    '9': 'WXYZ',
    '*': '',
    '0': '+',
    '#': '',
}

function DTMFButton({tone, disabled, onClick}) {
    return (
        <button
            key={tone}
            className={styles.button}
            disabled={disabled}
            onClick={onClick}
        >
            {tone}
            {SUB_LABELS[tone] && <span className={styles.sub}>{SUB_LABELS[tone]}</span>}
        </button>
    )
}

export default DTMFButton
